import { render, staticRenderFns } from "./FormComponentConfig.vue?vue&type=template&id=283e2568&scoped=true"
import script from "./FormComponentConfig.vue?vue&type=script&lang=js"
export * from "./FormComponentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e2568",
  null
  
)

export default component.exports